import { FormEvent, useState } from 'react';

const endpoint = (import.meta.env.VITE_APP_API_URL || import.meta.env.VITE_FEEDBACK_API_URL) as string | undefined;

type SubmitState = 'idle' | 'submitting' | 'success' | 'error';

export function FeedbackForm() {
  const [category, setCategory] = useState('전반');
  const [message, setMessage] = useState('');
  const [website, setWebsite] = useState('');
  const [state, setState] = useState<SubmitState>('idle');

  const submit = async (event: FormEvent) => {
    event.preventDefault();
    if (!endpoint || message.trim().length < 5) return;
    setState('submitting');
    try {
      const response = await fetch(`${endpoint.replace(/\/$/, '')}/feedback`, {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ category, message: message.trim(), website, page: window.location.pathname }),
      });
      if (!response.ok) throw new Error('feedback_failed');
      setMessage('');
      setState('success');
    } catch {
      setState('error');
    }
  };

  return (
    <section className="feedback" id="feedback" aria-labelledby="feedback-title">
      <div className="feedback__copy">
        <span className="eyebrow eyebrow--light">베타에 함께해 주세요</span>
        <h2 id="feedback-title">이름 없이 의견을 남겨주세요</h2>
        <p>불편한 점, 원하는 기능, 장기 규칙에 관한 의견을 모두 읽고 다음 배포에 반영하겠습니다.</p>
        <div className="privacy-note">
          이름과 이메일을 받지 않습니다. 작성 내용과 분류, 작성 시각만 저장하며 1년 뒤 자동 삭제합니다.
        </div>
      </div>
      <form className="feedback-form" onSubmit={submit}>
        <label>
          어떤 의견인가요?
          <select value={category} onChange={(event) => setCategory(event.target.value)}>
            <option>전반</option>
            <option>장기판</option>
            <option>박보</option>
            <option>대국</option>
            <option>배우기</option>
            <option>오류</option>
            <option>제안</option>
          </select>
        </label>
        <label>
          의견
          <textarea
            minLength={5}
            maxLength={2000}
            required
            placeholder="예: 모바일에서 장기알이 조금 더 컸으면 좋겠습니다."
            value={message}
            onChange={(event) => { setMessage(event.target.value); setState('idle'); }}
          />
        </label>
        <label className="honeypot" aria-hidden="true">
          웹사이트
          <input tabIndex={-1} autoComplete="off" value={website} onChange={(event) => setWebsite(event.target.value)} />
        </label>
        <div className="feedback-form__footer">
          <span>{message.length}/2,000</span>
          <button className="primary-button primary-button--paper" disabled={state === 'submitting' || !endpoint} type="submit">
            {state === 'submitting' ? '보내는 중…' : '익명으로 보내기'}
          </button>
        </div>
        {state === 'success' && <p className="form-message form-message--success">의견이 안전하게 접수되었습니다. 감사합니다.</p>}
        {state === 'error' && <p className="form-message form-message--error">전송하지 못했습니다. 잠시 뒤 다시 시도해 주세요.</p>}
        {!endpoint && <p className="form-message">배포 설정을 연결하는 중입니다.</p>}
      </form>
    </section>
  );
}
